import { Navigate } from 'react-router-dom';

import useRolesCondition from '@/utils/useRolesCondition';

export default function Settings() {
  const { settingsPlatformTabDisplay, settingsUserMangementTabDisplay } =
    useRolesCondition(true);
  return (
    <div>
      {settingsPlatformTabDisplay && (
        <Navigate to="platform-settings" replace />
      )}
      {settingsUserMangementTabDisplay && (
        <Navigate to="users-management" replace />
      )}
    </div>
  );
}
